import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "bankConfig";

const bankConfigUrl = "/api/machines/BankConfig";

export const bankConfigLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Bank Config",
    url: bankConfigUrl,
  }
);
